import type { NavigationId, NavigationOption } from '@/types/navigation/Sidebar'

const COMMERCIAL_NAVIGATION_IDS: ReadonlySet<NavigationId> = new Set([
  'inbox',
  'schedules',
  'search',
])

export const isCommercialNavigationOption = (option: NavigationOption) =>
  COMMERCIAL_NAVIGATION_IDS.has(option.id)

// Pathname segments owned by the commercial-only navigation destinations
// above (opportunity search pages, /schedules, /monitors) plus commercial-only
// pages reachable outside the sidebar (/bookmarks). FedRAMP builds physically
// omit these pages, so FedRAMP navigation must route away from them.
const COMMERCIAL_ONLY_PATH_SEGMENTS = [
  '/search',
  '/schedules',
  '/monitors',
  '/bookmarks',
] as const

export const isCommercialOnlyPathname = (pathname: string) =>
  COMMERCIAL_ONLY_PATH_SEGMENTS.some((segment) => pathname.includes(segment))

export const isActive = (
  option: NavigationOption,
  pathname: string | null,
  activeOverride: boolean = false,
): boolean => {
  return (
    option.match(pathname ?? '') ||
    (option.children ?? []).some((child) =>
      isActive(child, pathname, activeOverride),
    ) ||
    (activeOverride ?? false)
  )
}
